export const ru = {
    delete_companion: 'Удалить попутчика',
    not_found_error_title: 'Попутчик не существует или у вас нет доступа',
    not_found_error_description: 'Для получения доступа обратитесь к координатору',
    to_the_main_action: 'На главную',
};
